const site = 'https://www.mayan-jo.com';

export const seo = {
  home: {
    title: 'MAYAN Technology | Engineering, IT & Industrial Solutions — Jordan',
    description:
      'MAYAN Technology, established in 2006 in Amman, provides engineering services, industrial equipment, economic studies, and IT and telecom solutions from concept to completion.',
    path: '/',
  },
  about: {
    title: 'About MAYAN Technology | Established in Jordan Since 2006',
    description:
      'Learn about MAYAN Technology, a Jordanian engineering and consultation firm offering industrial research, feasibility studies, equipment supply, and IT and telecom solutions.',
    path: '/about',
  },
  partners: {
    title: 'Partners | MAYAN Technology',
    description:
      'MAYAN Technology works with specialised engineering, industrial, and technology partners to deliver equipment, materials, and professional solutions.',
    path: '/partners',
  },
  services: {
    title: 'Services | Engineering, Energy, Laboratory & Industrial Supply — MAYAN',
    description:
      'MAYAN services include economic studies, oil and gas, power and water, radiation monitoring, laboratory equipment, process control, mineral industries, and meteorology.',
    path: '/services',
  },
  solutions: {
    title: 'Solutions | IT, Telecom, Military & Manpower — MAYAN Technology',
    description:
      'MAYAN solutions cover IT and AI platforms, telecom infrastructure, military equipment and logistics, and skilled manpower for industrial and government sectors.',
    path: '/solutions',
  },
  clients: {
    title: 'Clients | MAYAN Technology',
    description:
      'MAYAN Technology serves organisations in Jordan and the region across energy, water, industry, government, and research.',
    path: '/clients',
  },
  careers: {
    title: 'Careers | Join MAYAN Technology',
    description:
      'Send your message or CV to MAYAN Technology in Amman. We welcome applications from engineers, technicians, and skilled professionals.',
    path: '/careers',
  },
  contact: {
    title: 'Contact Us | MAYAN Technology — Amman, Jordan',
    description:
      'Contact MAYAN Technology in Umm al-Summaq, Amman. Email info@mayan-jo.com or visit Building #88, Princess Zein bint Al-Hussein Street.',
    path: '/contact',
  },
  privacy: {
    title: 'Privacy Policy | MAYAN Technology',
    description: 'How MAYAN Technology handles information submitted through this website.',
    path: '/privacy',
  },
  terms: {
    title: 'Terms of Service | MAYAN Technology',
    description: 'Terms of use for the MAYAN Technology website.',
    path: '/terms',
  },
};

export const siteOrigin = site;
